import React from 'react';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';

import UserRolesList from '../UserRolesList';
import CreateUserModal from '../CreateUserModal';
import EditUserForm from '../EditUserForm';

import GrantsList from './GrantsList.jsx';
import UserDetails from './UserDetails.jsx';
import UsersList from './UsersList.jsx';

import AccountStaffResetPasswordForm from './../AccountStaffPasswordManageForms/AccountStaffResetPasswordForm';
import Loading from '../Loading';
import { AdminUsersWrapper, AdminUsersContentWrapper, AdminUserContentLhs, AdminUsersTopMenu, AdminUserSearchInput, AdminUserSearchInputWrapper, AdminUserContent } from 'src/components/AdminUsers/AdminUsers.style.ts';

function searchUser(user, string) {
    if (!string) {
        return true;
    }

    const pattern = new RegExp(string, 'i');

    return (
        user.get('name').search(pattern) !== -1 ||
        user.get('email').search(pattern) !== -1 ||
        user.get('status').search(pattern) !== -1
    );
}

class AdminUsers extends React.Component {
    static propTypes = {
        onUserQueryRequest: PropTypes.func,
        onUserUpdateRequest: PropTypes.func,
        onPermissionsGetRequest: PropTypes.func,
        onRolesGetRequest: PropTypes.func,

        users: ImmutablePropTypes.map,
        roles: ImmutablePropTypes.map,
        permissions: ImmutablePropTypes.map,
        loading: PropTypes.bool
    };

    static defaultProps = {
        users: Map(),
        roles: Map(),
        permissions: Map()
    };

    constructor(props) {
        super(props);

        this.state = {
            selectedRole: null,
            selectedUser: null,
            newRoles: null,
            showCreateModal: false,
            showResetPasswordForm: false,
            isError: false,
            tableauInput: ''
        };

    }

    componentDidMount() {

        this.props.onPermissionsGetRequest();
        this.props.onUserQueryRequest();
        this.props.onRolesGetRequest();
    }

    UNSAFE_componentWillReceiveProps(props) {
        let state;

        if (!this.state.selectedUser) {
            const firstUser = props.users.first();
            const userId = firstUser && `${ firstUser.get('id')}`;

            state = {
                selectedUser: userId
            };
            if (userId !== undefined) {
                const tableauAccessLogin = props.users.get(userId).get('tableauAccessLogin');

                state = {
                    ...state,
                    isError: false,
                    tableauInput: tableauAccessLogin
                };
            }
        }

        if (!this.state.selectedRole) {
            const rolesGroup = props.roles.first();
            state = {
                ...state,
                selectedRole: rolesGroup ? rolesGroup.get('id') : null
            };
        }

        if (state) {
            this.setState(state);
        }
    }

    onTableauInputChange = (event) => {
        this.setState({
            tableauInput: event.target.value
        });
    };

    onUsersSearch(e) {
        this.setState({ query: e.target.value });
    }

    selectRole(role) {
        this.setState({
            selectedRole: role.get('id')
        });
    }

    selectUser(user) {
        const userId = `${user.get('id')}`;
        this.setState({
            selectedUser: userId,
            editing: false
        });
        const tableauAccessLogin = this.props.users.get(userId).get('tableauAccessLogin');
        this.setState({
            isError: false,
            tableauInput: tableauAccessLogin
        });
    }

    onRoleChange(newRoles) { }

    showUserCreateModal() {
        this.setState({
            showCreateModal: true
        });
    }
    hideCreateUserModal() {
        this.setState({
            showCreateModal: false
        });
    }

    save({ id, roles, surname, firstName, jobTitle, email }) {
        this.props.onUserUpdateRequest(id, {
            id,
            jobTitle,
            surname,
            firstName,
            email,
            roles
        });
        if (this.props.tableauDashboards === true) {
            this.grantTableauAccess();
        }

        this.setState({
            editing: false
        });
    }
    resetPassword(action) {
        this.setState({
            showResetPasswordForm: action
        });

    }
    edit() {
        this.setState({
            editing: !this.state.editing
        });
    }
    suspend() {
        if (!this.state.selectedUser) {
            return;
        }
        this.props.onUserUpdateRequest(
            this.state.selectedUser, { status: 'suspended', statusDescription: 'User suspended by Admin' }
        );
    }
    activate() {
        if (!this.state.selectedUser) {
            return;
        }
        this.props.onUserUpdateRequest(
            this.state.selectedUser, { status: 'active', statusDescription: 'User activated by Admin' }
        );
    }
    remove() {
        if (!this.state.selectedUser) {
            return;
        }
        this.props.onUserUpdateRequest(
            this.state.selectedUser, { status: 'closed' }
        );
    }

    grantTableauAccess = async () => {
        try {
            if (this.props.isSuperUser === true) {

                const response = await this.props.sdkStaff.tableauBackofficeAccessChange({
                    staffId: this.state.selectedUser,
                    tableauAccessLogin: this.state.tableauInput
                });
                if (response.tableauAccessLogin !== undefined) {
                    this.setState({
                        isError: false,
                    });
                }
            } else {
                this.setState({
                    tableauInput: '',
                    isError: true,
                });
                return;
            }
        } catch (error) {
            console.error('Api error:', error);
            this.setState({
                tableauInput: '',
                isError: true
            });
        }
    };

    render() {
        let { selectedRole, selectedUser, editing, showResetPasswordForm,
            tableauInput, isError } = this.state;
        const { users, roles } = this.props;

        selectedUser = users.get(selectedUser);
        selectedRole = roles.get(selectedRole);
        let content;

        const userEditForm = (
            <div className='col-8'>
                <EditUserForm
                    roles={roles}
                    user={selectedUser}

                    onRoleSelect={this.selectRole.bind(this)}
                    onSubmit={this.save.bind(this)}

                    onDeleteRequest={this.remove.bind(this)}
                    onSuspendRequest={this.suspend.bind(this)}
                    onActivateRequest={this.activate.bind(this)}
                    onCancelEditing={[this.edit.bind(this), this.resetPassword.bind(this, true)]}

                    tableauInput={tableauInput}
                    onTableauInputChange={this.onTableauInputChange}
                    grantTableauAccess={this.grantTableauAccess}
                    isSuperUser={this.props.isSuperUser}
                    tableauDashboards={this.props.tableauDashboards}
                />
            </div>
        );

        if (selectedUser) {
            const suspendButton = (
                <button onClick={this.suspend.bind(this)} type='button' className='btn'>
                    Suspend
                </button>
            );
            const activateButton = (
                <button onClick={this.activate.bind(this)} type='button' className='btn'>
                    Activate
                </button>
            );
            const deleteButton = (
                <button onClick={this.remove.bind(this)} type='button' className='btn'>
                    Delete
                </button>
            );

            const userPreview = (
                <div className='col-8'>
                    <div className='row'>
                        <div className='col-6'>
                            <UserDetails
                                user={selectedUser}
                                tableauLogin={tableauInput}
                                isError={isError}
                                isSuperUser={this.props.isSuperUser}
                                tableauDashboards={this.props.tableauDashboards}
                                staffId={this.props.sdkStaff.session.userId}
                            />
                            {showResetPasswordForm ? <AccountStaffResetPasswordForm user={selectedUser} resetPassword={this.resetPassword.bind(this, false)} /> : null}
                        </div>
                        <div className='col-6'>
                            <h3>Roles</h3>
                            <UserRolesList
                                user={selectedUser}
                                initialRoles={selectedUser.get('roles')}
                                onRoleSelect={this.selectRole.bind(this)}
                                onRoleChange={this.onRoleChange.bind(this)}
                                disabled={!editing}
                                editing={true}
                                roles={this.props.roles}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12 admin-users__menu'>
                            <button onClick={this.resetPassword.bind(this, true)} type='button' className='btn'>
                                Reset Password
                            </button>
                            <button onClick={this.edit.bind(this)} type='button' className='btn' data-test='edit-button'>
                                Edit
                            </button>
                            {selectedUser.get('status') === 'active' ? suspendButton : activateButton}
                            {selectedUser.get('status') !== 'closed' ? deleteButton : undefined}
                        </div>
                    </div>
                </div>
            );


            content = (
                <div className='admin-users__user-section'>
                    <div className='row'>
                        {editing ? userEditForm : userPreview}
                        <div className='col-4'>
                            <h3>{selectedRole && selectedRole.get('name')}</h3>
                            {
                                selectedRole ? (
                                    <GrantsList
                                        permissions={this.props.permissions}
                                        grants={selectedRole.get('grants')}
                                    />
                                ) : undefined
                            }
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <AdminUsersWrapper className='admin-users'>
                <AdminUsersTopMenu>
                    <button
                        className='btn btn-add'
                        onClick={this.showUserCreateModal.bind(this)}
                    >
                        Add user
                    </button>
                </AdminUsersTopMenu>

                <AdminUsersContentWrapper>
                    <AdminUserContentLhs>
                        <AdminUserSearchInputWrapper>
                            <AdminUserSearchInput
                                type='text'
                                onChange={this.onUsersSearch.bind(this)}
                                data-test='admin-user-search-input'
                            />
                        </AdminUserSearchInputWrapper>
                        <UsersList
                            onUserClick={this.selectUser.bind(this)}
                            users={this.props.users.filter(u => searchUser(u, this.state.query))} />
                    </AdminUserContentLhs>

                    <AdminUserContent data-test='admin-user-content'>
                        {content}
                    </AdminUserContent>
                </AdminUsersContentWrapper>

                <CreateUserModal
                    onClose={this.hideCreateUserModal.bind(this)}
                    onFinish={this.hideCreateUserModal.bind(this)}
                    active={this.state.showCreateModal}
                />

                <Loading active={this.props.loading} />
            </AdminUsersWrapper>

        );
    }
}

export default AdminUsers;
